import {
  List,
  TextField,
  EditButton,
  ShowButton,
  SimpleList,
  Datagrid,
  BooleanField,
  CreateButton,
  TopToolbar,
} from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { DIRECTIONS, MOBILE_BREAKPOINT } from "../../../utils/constants";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { AdministrationExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListDirections = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={AdministrationExporter(DIRECTIONS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Направления"
      sx={settings.style.expandStyle}
      actions={ListActions(checkPermission(getPermissions(), permissions.canCreateDirections))}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow fields={[{ label: "КСК", value: record.providesCampaigns ? "Да" : "Не" }]} />
              <MobileListRow
                fields={[
                  { label: "КСК с различни изпити", value: record.canCandidateWithDifferentExams ? "Да" : "Не" },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Отделна кампания за платено обучение",
                    value: record.hasSeparatePaidCampaign ? "Да" : "Не",
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateDirections) && <EditButton label="" />}
              {checkPermission(userPermissions, permissions.canPreviewDirections) && <ShowButton label="" />}
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <BooleanField
            source="providesCampaigns"
            label="КСК"
            sortable={false}
          />
          <BooleanField
            source="canCandidateWithDifferentExams"
            label="КСК с различни изпити"
            sortable={false}
          />
          <BooleanField
            source="hasSeparatePaidCampaign"
            label="Отделна кампания за платено обучение"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateDirections) && <EditButton />}
          {checkPermission(userPermissions, permissions.canPreviewDirections) && <ShowButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListDirections;
